import { enumExtractionKey } from "./extractions";

export const images = {
  [enumExtractionKey.PURCHASE_ORDER]: {
    url: "/demo-purchase-order.png",
    expiration: 1918615661,
  },
  [enumExtractionKey.INVOICE]: {
    url: "/demo-invoice.png",
    expiration: 1918615661,
  },
  [enumExtractionKey.BILL_OF_LADING]: {
    url: "/demo-bill-of-lading.png",
    expiration: 1918615661,
  },
  [enumExtractionKey.PICK_PACK_LIST]: {
    url: "/demo-pick-pack-list.png",
    expiration: 1918615661,
  },
};
